<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { closeModal, updateShow } from '@/app/components/modal/modals';
import { DtModal } from '@dialpad/dialtone/vue3/lib/modal';
import DncImportUploadStep from '../DncImportUploadStep/DncImportUploadStep.vue';
import DncImportMapStep from '../DncImportMapStep/DncImportMapStep.vue';
import DncImportDetailsStep from '../DncImportDetailsStep/DncImportDetailsStep.vue';
import { DATA_QA as MODAL_WRAPPER_DATA_QA } from '@/app/components/modal/modal-wrapper.constants';
import { usePhoneCsvStore } from '@/stores';
import type { PhoneCsv } from '@/apis/generated/dialbunny';
import logger from '@/logger';

const log = logger.getChild('DncImport');

const examples = ref<string[]>([]);
const dncCsv = ref<PhoneCsv | null>(null);

const step = ref(0);
const show = ref(false);

const phoneCsvStore = usePhoneCsvStore();

log.debug('Mounting');

onMounted(() => {
  show.value = true;
  log.debug('Mounted');
});

const handleImportComplete = async () => {
  log.debug('Import complete, closing modal');

  await closeModal();

  await phoneCsvStore.refresh();
};
</script>
<template>
  <DtModal
    :data-qa="MODAL_WRAPPER_DATA_QA.DIALOG"
    :title="$ta('DNC_IMPORT_MODAL_TITLE')[`STEP_${step}`]"
    :close-button-props="{
      ariaLabel: $t('MODAL_CLOSE_ARIA_LABEL'),
      'aria-label': $t('MODAL_CLOSE_ARIA_LABEL'),
      'data-qa': MODAL_WRAPPER_DATA_QA.CLOSE,
    }"
    fixed-header-footer
    dialog-class="d-wmx912"
    content-class="d-wmx912 d-p4 d-mn4"
    :show="show"
    @update:show="updateShow"
  >
    <DncImportUploadStep
      v-show="step === 0"
      v-model="dncCsv"
      @update:examples="($event) => (examples = $event)"
      @continue="step = 1"
    />
    <DncImportMapStep
      v-show="step === 1"
      v-model="dncCsv"
      :examples="examples"
      @back="step = 0"
      @continue="step = 2"
    />
    <DncImportDetailsStep
      v-if="dncCsv"
      v-show="step === 2"
      :dnc-csv="dncCsv"
      @back="step = 1"
      @continue="handleImportComplete"
    />
  </DtModal>
</template>
